import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import i18n from 'i18n';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import { isObjectEmptyString } from 'Utils/ObjectUtils';
import { Icon } from 'Components/UI/Icon';
import UploadAvatar from 'Components/UI/UploadAvatar';
import FieldControled from 'Components/UI/FieldControled';
import schema from './cadastroTab.schema';
import { CadastroWrapper } from './styles';

interface ICadastroTab {
  isSubmited?: boolean;
  constructionSiteId?: number;
  name?: string;
  type?: string;
  address?: string;
  avatarFileName?: string;
  listObras?: IObraResponse[];
  onSubmit: (values?: any, errors?: string[]) => void;
}

const CadastroTab: FC<ICadastroTab> = ({
  isSubmited,
  name,
  type,
  address,
  avatarFileName,
  listObras,
  constructionSiteId,
  onSubmit,
}) => {
  const { t } = useTranslation('obras');
  const [imageConstruction, setImageConstruction] = useState(avatarFileName);

  const {
    control,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Name: name || '',
      Type: type || '',
      Address: address || '',
    },
    resolver: yupResolver(schema),
  });

  const onUploadImageConstruction = (uploadedImage: string) => {
    setImageConstruction(uploadedImage);
  };

  const hasConstructionSameName = (nameConstruction: string) => {
    const IdConstructionSameName = listObras?.find((obra) => obra.Name === nameConstruction)?.ConstructionSiteId;
    return IdConstructionSameName && IdConstructionSameName !== constructionSiteId;
  };

  const submit = (values: any, errorsArray?: string[]) => {
    let errorsArrayLocal: string[] | undefined = errorsArray;
    if (values) {
      if (hasConstructionSameName(values.Name)) {
        errorsArrayLocal = [i18n.t('obras:cadastroObra.errors.repeatedName')];
      }
      values.AvatarFileName = imageConstruction;
    }
    onSubmit(values, errorsArrayLocal);
  };

  useEffect(() => {
    setImageConstruction(avatarFileName);
  }, [name, avatarFileName]);

  if (isSubmited) {
    if (errors && !isObjectEmptyString(errors)) {
      submit(undefined, []);
    } else {
      handleSubmit((data) => submit(data, undefined))();
    }
  }

  return (
    <CadastroWrapper img={`${process.env.REACT_APP_IMAGE_STORAGE_URL}${imageConstruction}`}>
      <UploadAvatar onUploadImage={onUploadImageConstruction}>
        {(isLoading: boolean) => {
          return (
            <div className="changeImageWrapper">
              {isLoading
                ? (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        color='white'
                        style={{ fontSize: 40, color: 'white' }}
                      />
                    }
                  />
                ) : (
                  <>
                    <Icon color='branco' customSize={19} icon='editarImg' />
                    <span className="changeImageLabel" >{t('cadastroObra.cadastroTab.changeImage')}</span>
                  </>
                )}
            </div>
          );
        }}
      </UploadAvatar>

      <div className="formWrapper">
        <form>
          <FieldControled
            label={t('cadastroObra.cadastroTab.nameLabel')}
            name='Name'
            className="fieldCadastro"
            control={control}
            trigger={trigger}
          />
          <FieldControled
            label={t('cadastroObra.cadastroTab.typeLabel')}
            name='Type'
            className="fieldCadastro"
            control={control}
            trigger={trigger}
          />
          <FieldControled
            label={t('cadastroObra.cadastroTab.addressLabel')}
            name='Address'
            className="fieldCadastro"
            control={control}
            trigger={trigger}
          />
        </form>
      </div>
    </CadastroWrapper>
  );
};

export default CadastroTab;
